import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';

export default class RoadmapTableInitiativeController extends Controller {
  @service initiativeSlideover;
  @service router;
  @service intl;
  @service('beta-toggle') betaService;
  @service('organisation') orgService;
  @service initiatives;
  @service store;
  @service chatv2;

  queryParams = ['originUrl'];

  @tracked summaryPanelIsOpen;
  @tracked originUrl;

  constructor(owner, args) {
    super(owner, args);
    this.summaryPanelIsOpen = this._isDescriptionRoute();
    this.router.on('routeDidChange', this._onRouteChange);
  }

  willDestroy() {
    this.router.off('routeDidChange', this._onRouteChange);
    super.willDestroy();
  }

  _isDescriptionRoute() {
    return this.router.currentRouteName?.includes('description') ?? false;
  }

  _onRouteChange = () => {
    this.summaryPanelIsOpen = this._isDescriptionRoute();
  };

  get showSummaryPanel() {
    return !this.chatv2.chatWindowIsOpen && this.summaryPanelIsOpen;
  }

  get leftPanelColSpan() {
    if (this.chatv2.chatWindowIsOpen) return 'col-span-12';
    if (this.summaryPanelIsOpen) return 'col-span-8';
    return 'col-span-11';
  }

  get initiative() {
    return this.model;
  }

  get tabs() {
    const tabs = [
      {
        label: this.intl.t('_initiatives.description'),
        route: 'backlog.initiatives.initiative.description',
        key: 'description',
      },
      {
        label: this.intl.t('dictionary.artifact', { num: 2 }),
        route: 'backlog.initiatives.initiative.artifacts',
        key: 'artifacts',
        hide:
          !this.betaService.showKnowledgeBaseFeatures ||
          this.initiative.artifacts.content.length === 0,
      },
      {
        label: this.intl.t('dictionary.notes'),
        route: 'backlog.initiatives.initiative.notes',
        key: 'notes',
        hide: textDeltaIsEmpty(this.initiative.bon_notes),
      },
      {
        label: this.intl.t('dictionary.investment', { num: 2 }),
        route: 'backlog.initiatives.initiative.investments',
        key: 'investments',
      },
      {
        label: this.intl.t('dictionary.returns', { num: 2 }),
        route: 'backlog.initiatives.initiative.returns',
        key: 'returns',
      },
      {
        label: this.intl.t('dictionary.metrics', { num: 2 }),
        route: 'backlog.initiatives.initiative.metrics',
        key: 'initiative.metrics',
        hide: !this.betaService.showMetrics,
      },
      {
        label: this.intl.t('_initiatives.uncertainty', { num: 2 }),
        route: 'backlog.initiatives.initiative.uncertainties',
        key: 'uncertainties',
      },
      {
        label: this.intl.t('_initiatives.wfa', { num: 2 }),
        route: 'backlog.initiatives.initiative.waiting-for-answers',
        key: 'waiting-for-answers',
      },
      {
        label: this.intl.t('pages.document'),
        route: 'backlog.initiatives.initiative.document',
        key: 'document',
        hide:
          this.initiative.initiative_doc ||
          textDeltaIsEmpty(this.initiative.text_delta),
        external: this.initiative.initiative_doc,
      },
      {
        label: this.intl.t('_initiatives.weeks', { num: 2 }),
        route: 'backlog.initiatives.initiative.weeks',
        key: 'weeks',
        hide: !this.betaService.showPlanning,
      },
      {
        label: this.intl.t('pages.workstreams'),
        route: 'backlog.initiatives.initiative.workstreams',
        key: 'workstreams',
        hide: !this.betaService.showWorkstreams,
      },
      {
        label: this.intl.t('dictionary.knowledge-base'),
        route: 'backlog.initiatives.initiative.knowledge-base.list',
        key: 'knowledge-base',
        hide: !this.betaService.showKnowledgeBaseFeatures,
      },
    ];
    return tabs;
  }

  @action
  openPopOver() {
    this.initiativeSlideover.open(this.model.id);
  }

  @action
  isActive(tab) {
    return this.router.currentRouteName.includes(tab.key);
  }

  @action
  setInitiativeStatus(e) {
    this.initiative.status = e.value;
    this.initiative.save();
  }

  @action
  toggleSummaryPanel() {
    this.summaryPanelIsOpen = !this.summaryPanelIsOpen;
  }

  @action
  goToInitiative(e) {
    const currentRouteName = this.router.currentRoute.name;
    this.router.transitionTo(currentRouteName, e.id);
  }
}
